import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  _ReactiveState___get_raw__impl__92ipya10f5f3x6hwqt0 as _ReactiveState___get_raw__impl__92ipya,
  _ReactiveState___init__impl__fvdp9b2eqyidpf491cp as _ReactiveState___init__impl__fvdp9b,
  InternalReactiveWrapper6qytbrc1rcqv as InternalReactiveWrapper,
  Companion_getInstance1a6q7ejsqzzhs as Companion_getInstance,
  InternalReactiveThrownException1wn4fe03qbefg as InternalReactiveThrownException,
  InternalReactiveNotReady_instance37iasaqvolrrz as InternalReactiveNotReady_instance,
} from '../../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from './ContainingView.commonHtml.mjs';
import { get_centered1xfu6or5nc0lq as get_centered } from '../helpers.mjs';
import { ActivityIndicatork1oa7i2hevyv as ActivityIndicator } from './ActivityIndicator.commonHtml.mjs';
import { RawReactive253xb355brtjj as RawReactive } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { afterTimeout2ddqxaabn39mu as afterTimeout } from '../../afterTimeout.mjs';
import {
  listOfNotNull1v4ggfackvuny as listOfNotNull,
  emptyList1g2z5xcrvp2zy as emptyList,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { ImageScaleType_Fit_getInstanceowdhgt1q4kgg as ImageScaleType_Fit_getInstance } from '../../models/data.mjs';
import { firstOrNull1982767dljvdy as firstOrNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { _Duration___get_inWholeMilliseconds__impl__msfiry1byvgyrhm5g4a as _Duration___get_inWholeMilliseconds__impl__msfiry } from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { RawImageViewZoomable3s4y58x72taln as RawImageViewZoomable } from './RawImageView.commonHtml.mjs';
import { reactive2pl1t9wy5gll5 as reactive } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var InfoClass;
function Info() {
  if (InfoClass === VOID) {
    class $ {
      constructor(sources, scaleType, description) {
        this.mdb_1 = sources;
        this.ndb_1 = scaleType;
        this.odb_1 = description;
      }
      ada(sources, scaleType, description) {
        return new (Info())(sources, scaleType, description);
      }
      pdb(sources, scaleType, description, $super) {
        sources = sources === VOID ? this.mdb_1 : sources;
        scaleType = scaleType === VOID ? this.ndb_1 : scaleType;
        description = description === VOID ? this.odb_1 : description;
        return $super === VOID ? this.ada(sources, scaleType, description) : $super.ada.call(this, sources, scaleType, description);
      }
      toString() {
        return 'Info(sources=' + toString(this.mdb_1) + ', scaleType=' + this.ndb_1.toString() + ', description=' + this.odb_1 + ')';
      }
      hashCode() {
        var result = hashCode(this.mdb_1);
        result = imul(result, 31) + this.ndb_1.hashCode() | 0;
        result = imul(result, 31) + (this.odb_1 == null ? 0 : getStringHashCode(this.odb_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Info()))
          return false;
        if (!equals(this.mdb_1, other.mdb_1))
          return false;
        if (!this.ndb_1.equals(other.ndb_1))
          return false;
        if (!(this.odb_1 == other.odb_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Info');
    InfoClass = $;
  }
  return InfoClass;
}
function ZoomableImageView$refresh$lambda(this$0, $it) {
  return () => {
    this$0.qdb_1.uba($it);
    return Unit_instance;
  };
}
function ZoomableImageView$refresh$lambda_0($$this$rawImageZoomable, this$0, $info) {
  return ($this$reactive) => {
    // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
    var this_0 = $this$reactive.faj($$this$rawImageZoomable.vcd_1);
    var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(this_0);
    if (!equals(tmp0_subject, InternalReactiveNotReady_instance)) {
      if (tmp0_subject instanceof InternalReactiveThrownException()) {
        var it = _ReactiveState___get_raw__impl__92ipya(this_0).uah_1;
        if (equals(this$0.vdb_1, $info)) {
          this$0.xdb_1.gb7(0.0);
          this$0.ydb_1.rah(Companion_getInstance().wah(it));
        }
      } else {
        if (tmp0_subject instanceof InternalReactiveWrapper()) {
          var tmp = _ReactiveState___get_raw__impl__92ipya(this_0).tah_1;
          if (!(tmp == null ? true : !(tmp == null)))
            THROW_CCE();
          $$this$rawImageZoomable.gb7(1.0);
          if (equals(this$0.vdb_1, $info)) {
            this$0.xdb_1.gb7(0.0);
            this$0.ydb_1.rah(_ReactiveState___init__impl__fvdp9b($info));
          }
        } else {
          _ReactiveState___get_raw__impl__92ipya(this_0);
          $$this$rawImageZoomable.gb7(1.0);
          if (equals(this$0.vdb_1, $info)) {
            this$0.xdb_1.gb7(0.0);
            this$0.ydb_1.rah(_ReactiveState___init__impl__fvdp9b($info));
          }
        }
      }
    }
    return Unit_instance;
  };
}
function ActivityIndicator$_get_shown_$ref_61t2d1(p0) {
  return () => p0.yb8();
}
function ActivityIndicator$_set_shown_$ref_zcnirl(p0) {
  return (_this__u8e3s4) => {
    p0.jb7(_this__u8e3s4);
    return Unit_instance;
  };
}
var ZoomableImageViewClass;
function ZoomableImageView() {
  if (ZoomableImageViewClass === VOID) {
    class $ {
      constructor(viewWriter) {
        var tmp = this;
        // Inline function 'kotlin.with' call
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (Frame())(viewWriter.pc());
        var tmp0_elvis_lhs = viewWriter.ebb_1;
        var p = tmp0_elvis_lhs == null ? viewWriter : tmp0_elvis_lhs;
        viewWriter.gbb(p, view);
        viewWriter.hbb(p, view);
        tmp.qdb_1 = view;
        this.rdb_1 = null;
        this.sdb_1 = false;
        this.tdb_1 = false;
        this.udb_1 = false;
        this.vdb_1 = null;
        this.wdb_1 = null;
        // Inline function 'kotlin.with' call
        var $this$with = this.qdb_1;
        var tmp_0 = get_centered($this$with);
        // Inline function 'com.lightningkite.kiteui.views.direct.activityIndicator' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (ActivityIndicator())($this$with.pc());
        var tmp0_elvis_lhs_0 = $this$with.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? $this$with : tmp0_elvis_lhs_0;
        $this$with.gbb(p_0, view_0);
        this.xdb_1 = view_0;
        view_0.gb7(0.0);
        $this$with.hbb(p_0, view_0);
        $this$with.lbb(tmp_0, view_0);
        this.ydb_1 = RawReactive().aai(_ReactiveState___init__impl__fvdp9b(null));
        var tmp_1 = this;
        var tmp0 = this.xdb_1;
        var tmp_2 = KMutableProperty0();
        var tmp_3 = ActivityIndicator$_get_shown_$ref_61t2d1(tmp0);
        tmp_1.zdb_1 = getPropertyCallableRef('shown', 0, tmp_2, tmp_3, ActivityIndicator$_set_shown_$ref_zcnirl(tmp0));
      }
      cba() {
        return this.qdb_1;
      }
      ga2() {
        return this.qdb_1.ga2();
      }
      adc(value) {
        this.rdb_1 = value;
        if (this.udb_1) {
          afterTimeout(this, 10n, () => {
            this.pas();
            return Unit_instance;
          });
        }
      }
      qda(value) {
        var tmp0_safe_receiver = this.rdb_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.pdb(listOfNotNull(value));
        this.adc(tmp1_elvis_lhs == null ? new (Info())(listOfNotNull(value), ImageScaleType_Fit_getInstance(), null) : tmp1_elvis_lhs);
      }
      g2i() {
        var tmp0_safe_receiver = this.rdb_1;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.mdb_1;
        return tmp1_safe_receiver == null ? null : firstOrNull(tmp1_safe_receiver);
      }
      rda(value) {
        var tmp0_safe_receiver = this.rdb_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.pdb(VOID, value);
        var tmp;
        if (tmp1_elvis_lhs == null) {
          // Inline function 'kotlin.collections.listOf' call
          var tmp$ret$0 = emptyList();
          tmp = new (Info())(tmp$ret$0, value, null);
        } else {
          tmp = tmp1_elvis_lhs;
        }
        this.adc(tmp);
      }
      bbb() {
        this.udb_1 = true;
        this.pas();
      }
      pas() {
        if (!this.udb_1)
          return Unit_instance;
        var info = this.rdb_1;
        if (!equals(this.vdb_1, info)) {
          var tmp0_safe_receiver = this.wdb_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.collections.forEach' call
            var _iterator__ex2g4s = tmp0_safe_receiver.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              element.gb7(0.0);
              var tmp = _Duration___get_inWholeMilliseconds__impl__msfiry(element.mba().vb0_1);
              afterTimeout(this, tmp, ZoomableImageView$refresh$lambda(this, element));
            }
          }
          this.ydb_1.rah(Companion_getInstance().oah_1);
          this.vdb_1 = info;
          this.xdb_1.gb7(1.0);
          var tmp_0 = this;
          var tmp_1;
          if (info == null) {
            tmp_1 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.collections.buildList' call
            // Inline function 'kotlin.collections.buildListInternal' call
            // Inline function 'kotlin.apply' call
            var this_0 = ArrayList().w();
            // Inline function 'kotlin.with' call
            var $this$with = this.qdb_1;
            var _iterator__ex2g4s_0 = info.mdb_1.m1();
            while (_iterator__ex2g4s_0.n1()) {
              var imageSource = _iterator__ex2g4s_0.o1();
              var tmp0_elvis_lhs = info.odb_1;
              var tmp4 = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
              // Inline function 'com.lightningkite.kiteui.views.direct.rawImageZoomable' call
              var scaleType = info.ndb_1;
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view = new (RawImageViewZoomable())($this$with.pc(), imageSource, tmp4, scaleType);
              var tmp0_elvis_lhs_0 = $this$with.ebb_1;
              var p = tmp0_elvis_lhs_0 == null ? $this$with : tmp0_elvis_lhs_0;
              $this$with.gbb(p, view);
              view.gb7(0.0);
              reactive(view, ZoomableImageView$refresh$lambda_0(view, this, info));
              $this$with.hbb(p, view);
              this_0.v(view);
            }
            tmp_1 = this_0.c8();
          }
          var tmp2_elvis_lhs = tmp_1;
          var tmp_2;
          if (tmp2_elvis_lhs == null) {
            // Inline function 'kotlin.run' call
            this.ydb_1.rah(_ReactiveState___init__impl__fvdp9b(null));
            this.xdb_1.gb7(0.0);
            tmp_2 = null;
          } else {
            tmp_2 = tmp2_elvis_lhs;
          }
          tmp_0.wdb_1 = tmp_2;
        }
      }
    }
    initMetadataForClass($, 'ZoomableImageView', VOID, VOID, [CoroutineScope()]);
    ZoomableImageViewClass = $;
  }
  return ZoomableImageViewClass;
}
//region block: exports
export {
  ZoomableImageView as ZoomableImageView2th1eo3ejqzvg,
};
//endregion

//# sourceMappingURL=ZoomableImageView.mjs.map
